import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Bubble } from "ctia-ui";
import ErrorMsg from "components/ErrorMsg";
// import Controls from 'containers/request/Initial/Agreements/AgreementsControls';
import LicenseAgreement from "containers/request/Initial/Agreements/LicenseAgreement";
import { getAgreementInfo, cleanAgreementInfo } from "actions/agreement";
import { startPreloader, finishPreloader } from "actions/preloader";
import "containers/request/Initial/Agreements/style.css";

class RebrandAgreement extends Component {
  componentDidMount() {
    const {
      request,
      startPreloader,
      finishPreloader,
      getAgreementInfo,
      cleanAgreementInfo
    } = this.props;

    if (request.model && !_.isUndefined(request.model.id)) {
      startPreloader();
      getAgreementInfo(request.model.id, finishPreloader);
    } else {
      cleanAgreementInfo();
    }
  }

  componentWillUnmount() {
    this.props.cleanAgreementInfo();
  }

  render() {
    const { show, request, history } = this.props;

    if (!show) return null;

    if (request && request.submitError) {
      return <ErrorMsg error={request.submitError} history={history} />;
    }

    return (
      <div>
        <LicenseAgreement />
        <Bubble type="danger" icon="ban-circle">
          This is a DEMO for Re-Brand type submission. So, nothing will be saved
          to database from this point :-)
        </Bubble>
        {/* <Row>
          <Controls />
        </Row> */}
      </div>
    );
  }
}

RebrandAgreement.propTypes = {
  show: PropTypes.bool
};

RebrandAgreement.defaultProps = {
  show: true
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps, {
  startPreloader,
  finishPreloader,
  getAgreementInfo,
  cleanAgreementInfo
})(RebrandAgreement);



// WEBPACK FOOTER //
// ./src/containers/request/Rebrand/RebrandAgreement.js